/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonDocumentApprovalDocumentViewModel } from "../types/PersonDocumentApprovalDocumentViewModel.ts";
import { personDocumentApprovalAttachmentViewModelSchema } from "./personDocumentApprovalAttachmentViewModelSchema.ts";

export const personDocumentApprovalDocumentViewModelSchema = z.object({
  enrollmentDocumentId: z.optional(
    z.number().int().describe("ID do documento de matrícula (tipo)."),
  ),
  documentName: z
    .string()
    .describe("Nome do documento resolvido pelo idioma atual.")
    .nullish(),
  displayName: z
    .string()
    .describe('Nome de exibição na aba; RG aparece como "RG/CIN".')
    .nullish(),
  canBeReadByOcr: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o tipo é passível de leitura por OCR (RG, CPF ou Diploma de Pós).",
      ),
  ),
  showCopyButton: z.optional(
    z
      .boolean()
      .describe("Indica se a aba exibe botão de copiar o valor (RG e CPF)."),
  ),
  attachments: z
    .array(z.lazy(() => personDocumentApprovalAttachmentViewModelSchema))
    .describe(
      "Anexos enviados pelo aluno para o documento, do mais recente para o mais antigo.",
    )
    .nullish(),
}) as unknown as ToZod<PersonDocumentApprovalDocumentViewModel>;
